import { get } from "./request";
import request from "./request";

/**
 * 账单接口（API 文档第 7 节 /console/billing）。
 */

// ---------- 类型 ----------

/** GET /billing/summary */
export interface BillingSummary {
  /** 当月 API 调用总次数 */
  currentMonthCalls: number;
  /** 当月消费总额（分） */
  currentMonthCostCents: number;
}

/** GET /billing/months 单项 */
export interface BillingMonth {
  /** 月份 YYYY-MM */
  month: string;
  /** 该月调用总次数 */
  total_calls: number;
  /** 该月消费总额（分） */
  total_cost_cents: number;
}

/** GET /billing/months/{month}/details 单项 */
export interface BillingMonthDetail {
  date: string;
  api_code: string;
  calls: number;
  cost_cents: number;
}

// ---------- 接口 ----------

export function getBillingSummary(): Promise<BillingSummary> {
  return get<BillingSummary>("/billing/summary");
}

export function getBillingMonths(): Promise<BillingMonth[]> {
  return get<BillingMonth[]>("/billing/months");
}

export function getBillingMonthDetails(
  month: string
): Promise<BillingMonthDetail[]> {
  return get<BillingMonthDetail[]>(
    `/billing/months/${encodeURIComponent(month)}/details`
  );
}

/**
 * GET /billing/export：导出账单 CSV。
 * from/to 为 ISO instant。返回 Blob 供前端触发下载。
 */
export async function exportBillingCsv(params: {
  from?: string;
  to?: string;
} = {}): Promise<Blob> {
  const res = await request.get("/billing/export", {
    params,
    responseType: "blob",
  });
  return res as unknown as Blob;
}
